<template>
  <el-submenu
    :index="String('menu_' + item.arme_id + $randomNumber())"
    :key="'menu_' + item.arme_id + $randomNumber()"
  >
    <template #title>
      <el-checkbox
        v-if="isSaveMenu"
        v-model="item.selected"
        @change="handleItemChange"
      ></el-checkbox>
      <small>
        {{ item.arme_nombre }}
      </small>
    </template>

    <template v-for="child in item.children">
      <template v-if="isSubMenu(child)">
        <RecursiveSubmenu
          :item="child"
          :key="'menu_' + child.arme_id + $randomNumber()"
          :is-sub-menu="isSubMenu"
          :is-save-menu="isSaveMenu"
          @item-selected="handleSelected"
        ></RecursiveSubmenu>
      </template>
      <template v-else>
        <RecursiveMenuItem
          :item="child"
          :key="'menu_' + child.arme_id + $randomNumber()"
          :is-save-menu="isSaveMenu"
          @item-selected="handleSelected"
        ></RecursiveMenuItem>
      </template>
    </template>
  </el-submenu>
</template>

<script>
  import RecursiveMenuItem from './RecursiveMenuItem'
  export default {
    name: 'RecursiveSubmenu',
    components: {
      RecursiveMenuItem
    },
    props: {
      item: {
        type: Object,
        required: true
      },
      isSubMenu: {
        type: Function,
        required: true
      },
      isSaveMenu: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      handleSelected() {
        const hasSelectedChild = this.item.children.some(
          child => child.selected
        )
        if (hasSelectedChild) {
          this.item.selected = true
        } else {
          this.item.selected = false
        }
        this.$emit('item-selected', this.item)
      },
      handleItemChange() {
        this.toggleChildren(this.item, this.item.selected)
        this.$emit('item-selected', this.item)
      },
      toggleChildren(node, selected) {
        node.selected = selected
        if (node.children && node.children.length > 0) {
          node.children.forEach(child => {
            this.toggleChildren(child, selected)
          })
        }
      }
    }
  }
</script>
